__turbopack_context__.v({
  "blok-big-title": "AlgoliaSearchModal-module__ubYVTG__blok-big-title",
  "blok-subtitle": "AlgoliaSearchModal-module__ubYVTG__blok-subtitle",
  "blok-title": "AlgoliaSearchModal-module__ubYVTG__blok-title",
  "closeIcon": "AlgoliaSearchModal-module__ubYVTG__closeIcon",
  "content": "AlgoliaSearchModal-module__ubYVTG__content",
  "header": "AlgoliaSearchModal-module__ubYVTG__header",
  "root": "AlgoliaSearchModal-module__ubYVTG__root",
});
